/**
 * Firestore Timestamp / Date / 数値を、表示してよい更新日時だけに正規化する。
 * null や Unix epoch（1970-01-01）は未設定として null を返す。
 */
export function toRealDate(value: unknown): Date | null {
  if (value == null || value === '') return null;

  let date: Date | null = null;
  if (value instanceof Date) {
    date = value;
  } else if (typeof value === 'object') {
    const record = value as { toDate?: () => Date; seconds?: unknown };
    if (typeof record.toDate === 'function') {
      try {
        date = record.toDate();
      } catch {
        return null;
      }
    } else if (typeof record.seconds === 'number') {
      date = new Date(record.seconds * 1000);
    }
  } else if (typeof value === 'number') {
    date = new Date(value);
  } else if (typeof value === 'string') {
    date = new Date(value);
  }

  if (!date || Number.isNaN(date.getTime()) || date.getTime() <= 0) return null;
  return date;
}
